export interface FlattenTreeConditionProps<Type> {
  child: Type;
  isLeafNode: boolean;
  hasValidLeafNode: boolean;
}

export function flattenTree<Type extends { children?: Type[] }>(
  tree: Type,
  flatList: Type[] = [],
  condition?: (options: FlattenTreeConditionProps<Type>) => boolean
): boolean {
  // save leaf node
  if (!tree.children?.length) {
    const shouldInclude: boolean =
      !condition ||
      condition({ child: tree, isLeafNode: true, hasValidLeafNode: false });
    if (shouldInclude) {
      flatList.unshift(tree);
    }
    return shouldInclude;
  }

  let hasValidLeafNode: boolean = false;
  for (const child of tree.children) {
    if (flattenTree(child, flatList, condition)) {
      hasValidLeafNode = true;
    }
  }

  // save parent
  const shouldInclude: boolean = condition
    ? condition({ child: tree, isLeafNode: false, hasValidLeafNode })
    : hasValidLeafNode;
  if (shouldInclude) {
    flatList.unshift(tree);
  }
  return shouldInclude;
}
